<template>
    <a href="" class="text-white flex flex-col items-center space-x-2 px-4">
        <img v-if="companyLogoUrl" class="w-16 h-16 object-contain rounded" :src="companyLogoUrl" alt="Logo da clínica">
        <img :class="companyLogoUrl ? 'w-14 mt-2 opacity-70' : 'w-32'" src="../assets/logo.png" alt="sirimmatrix Logo">
        <h2 v-if="!companyLogoUrl" class="font-black mt-2 text-xs text-cyan-500 uppercase">{{ accountLabel }}</h2>
        <p v-if="loggedUserName" class="mt-2 text-[11px] font-semibold text-gray-400 text-center">
            {{ loggedUserName }}
        </p>
    </a>
</template>

<script>
import { ref, onMounted, onUnmounted } from 'vue';
import AuthService from '../services/AuthService';
import { CompanyService } from '../services/Entity';

export default {
    name: 'SidebarBrand',
    setup() {
        const companyLogoUrl = ref(null);
        const loggedUserName = ref('');
        const accountLabel = ref('Conta Básica');

        function onLogoUpdated(event) {
            companyLogoUrl.value = event.detail?.logoUrl || null;
        }

        onMounted(async () => {
            window.addEventListener('company-logo-updated', onLogoUpdated);

            const authInfo = await AuthService.getAuthInfo();
            loggedUserName.value = authInfo?.name || '';

            if (authInfo?.subscription_status === 'trial') {
                accountLabel.value = 'Período Teste';
            }

            if (authInfo && authInfo.company) {
                try {
                    const { data } = await CompanyService.getById(authInfo.company);
                    companyLogoUrl.value = (data && data.logo_url) || null;
                    if (authInfo.subscription_status !== 'trial') {
                        const labels = { basico: 'Conta Básica', standard: 'Conta Standard', premium: 'Conta Premium' };
                        accountLabel.value = labels[data?.plan] || 'Conta Básica';
                    }
                } catch (e) { /* mantém branding padrão */ }
            }
        });

        onUnmounted(() => {
            window.removeEventListener('company-logo-updated', onLogoUpdated);
        });

        return { companyLogoUrl, loggedUserName, accountLabel };
    }
}
</script>
